<template>
  <div>
    <v-expand-transition>
      <sds-card v-if="showFilter" width="282px">
        <div class="subtitle">
          <div>
            <v-btn icon @click="$emit('close')">
              <v-icon>
                {{ mdiMenuOpen }}
              </v-icon>
            </v-btn>
            <span> Filtros de Resultados </span>
          </div>
          <v-btn
            outlined
            color="black"
            class="pa-0"
            style="min-width: 35px"
            @click="expandirTodos"
          >
            <v-icon>
              {{
                btnExpand ? mdiUnfoldMoreHorizontal : mdiUnfoldLessHorizontal
              }}
            </v-icon>
          </v-btn>
        </div>

        <div v-for="(item, index) in filtroInterno" :key="item.campo + index">
          <div class="style-header">
            <div>{{ item.label }}</div>
            <ChevronUpDown v-model="item.expandido" />
          </div>
          <v-expand-transition>
            <div v-if="item.expandido" class="style-content">
              <v-row
                v-for="(subFilter, i) in item.valoresSubFiltroResponseDTO"
                :key="i"
                class="ma-0 px-1 py-2 flex-nowrap align-center justify-space-between"
              >
                <v-row class="ma-0 flex-nowrap">
                  <v-icon class="mr-1">
                    {{ mdiChevronDown }}
                  </v-icon>
                  <v-checkbox
                    v-model="subFilter.checked"
                    class="ma-0 pa-0"
                    :label="subFilter.descricao"
                    hide-details
                    @change="$emit('change', filtroInterno)"
                  />
                </v-row>
                <div class="style-chip">{{ subFilter.quantidade }}</div>
              </v-row>
            </div>
          </v-expand-transition>
        </div>
        <v-card-actions class="pa-0 pt-4">
          <v-col class="d-flex justify-end pa-0">
            <v-btn text color="primary" small @click="$emit('limpar')">
              Limpar
            </v-btn>
            <v-btn small color="primary" class="ml-2" @click="$emit('filtrar')">
              Filtrar
            </v-btn>
          </v-col>
        </v-card-actions>
      </sds-card>
    </v-expand-transition>
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import { useVModel } from '@vueuse/core';
import { mdiChevronDown, mdiMenuOpen } from '@mdi/js';
import { mdiUnfoldLessHorizontal, mdiUnfoldMoreHorizontal } from '@mdi/js';
import ChevronUpDown from './ChevronUpDown.vue';

interface IProps {
  value?: IFilters[];
  showFilter: boolean;
}

interface IEmits {
  (event: 'update:modelValue', value: IFilters[] | undefined): void;
  (event: 'change', value: IFilters[] | undefined): void;
  (event: 'close'): void;
  (event: 'limpar'): void;
  (event: 'filtrar'): void;
}

interface IFilters {
  expandido: boolean;
  campo: string;
  label: string;
  valoresSubFiltroResponseDTO: IValoresSubFiltro[];
}

interface IValoresSubFiltro {
  checked: boolean;
  descricao: string;
  quantidade: string;
}

const props = defineProps<IProps>();
const emit = defineEmits<IEmits>();

const btnExpand = ref(true);

const expandirTodos = () => {
  btnExpand.value = !btnExpand.value;
  filtroInterno.value?.forEach((element) => {
    element.expandido = !btnExpand.value;
  });
};

const filtroInterno = useVModel(props, 'value', emit);
</script>
<style lang="scss" scoped>
.subtitle {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 8px;
  font-size: 14px;
  font-weight: bold;
}

.style-header {
  background-color: #f5f5f5;
  padding: 0 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 2.375rem;
  color: var(--Surface-Icon, #666);
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.style-content {
  max-height: 140px;
  overflow-y: auto;
  ::v-deep label {
    color: var(--Surface-Black, #252525);
    text-overflow: ellipsis;
    font-size: 0.75rem !important;
    font-style: normal;
    line-height: normal;
  }
}

.style-chip {
  display: flex;
  padding: 0.0625rem 0.1875rem 0.125rem 0.125rem;
  align-items: center;
  gap: 0.625rem;
  border-radius: 30.75rem;
  background: var(--Surface-Medium, #a4a4a4);

  color: var(--Surface-White, #fff);
  text-align: right;

  /* Top Icon */
  font-family: Open Sans;
  font-size: 0.59375rem;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
</style>
